import { render, staticRenderFns } from "./UrunDetay.vue?vue&type=template&id=5df523ce&scoped=true&"
import script from "./UrunDetay.vue?vue&type=script&lang=js&"
export * from "./UrunDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df523ce",
  null
  
)

export default component.exports